import { atom } from 'nanostores';

/** Initial content for a new fax draft; structurally a `DocumentDraftSeed`. */
export interface FaxEditorSeed {
  id?: string;
  bodyMarkdown?: string;
  attachments?: Array<{ attachmentId: string; filename: string; mimeType: string }>;
}

export interface FaxEditorRequest {
  requestId: number;
  patientId: string;
  draftId?: string;
  seed?: FaxEditorSeed;
}

export const $faxEditorRequest = atom<FaxEditorRequest | null>(null);

let nextRequestId = 0;

export function openFaxEditor(
  patientId: string,
  request: Omit<FaxEditorRequest, 'patientId' | 'requestId'> = {}
): void {
  nextRequestId += 1;
  $faxEditorRequest.set({ ...request, patientId, requestId: nextRequestId });
}

export function closeFaxEditor(): void {
  $faxEditorRequest.set(null);
}
